// search for event id in the agenda recursively through children
import axios from "axios"
import find from "lodash/find"

const findEventById = (id, events) => {
    for (let i = 0; i < events.length; i += 1) {
        if (events[i].id === id) {
            return events[i]
        } else {
            if (events[i].children) {
                const childrenResult = findEventById(id, events[i].children)
                if (childrenResult) return childrenResult
            }
        }
    }

    return false
}

const findParent = (menu, item, array) => {
    array = typeof array === "undefined" ? [] : array

    if (item.parent === null) {
        return array
    } else {
        const parent = find(menu, ["id", item.parent.id])
        array.push(parent)
        return findParent(menu, parent, array)
    }
}

const getChannelEvents = (channel, agenda) => {
    if (channel.channelType === "sessionType") {
        return agenda.filter(event => {
            return event.session_type_id === parseInt(channel.sessionTypeID, 10)
        })
    } else {
        return agenda.filter(event => {
            return event.tracks.includes(channel.sessionTypeID)
        })
    }
}

const addChannelSlugToAllChildren = (event, slug) => {
    event.children.map(subevent => {
        subevent.channelSlug = slug
        if (subevent.children?.length) {
            addChannelSlugToAllChildren(subevent, slug)
        }
    })
}

/*
 * Send a message to slack
 * CURRENTLY NOT IN USE
 * logging now done through logtail/betterstack
 */

const sendToSlack = message => {
    const slackUrl = process.env.NEXT_PUBLIC_SLACK_WEBHOOK
    let text

    send().catch(err => console.log(err))

    async function send() {
        if (typeof document !== "undefined") {
            text = `Client: ${document.location.href} ${message} || ${window.navigator?.userAgent}`
        } else {
            text = message
        }

        const res = await axios.post(
            slackUrl,
            {
                text: text,
            },
            {
                headers: {
                    "Content-type": "application/x-www-form-urlencoded",
                },
            },
        )
    }
}

const isAppView = userAgent => {
    const _userAgent = userAgent || navigator?.userAgent || navigator?.vendor || window?.opera || ""
    return /iPad|iPhone|iPod|android|windows phone/.test(_userAgent)
}

export { findEventById, findParent, getChannelEvents, addChannelSlugToAllChildren, sendToSlack, isAppView }
